import { useAuth0 } from '@auth0/auth0-react'
import ProyectosArraySkeleton from 'components/Loaders/ProyectosArraySkeleton'
import ProyectoCardItem from 'components/Proyectos/ProyectoCardItem'
import Pagination from 'components/ui/Pagination/Pagination'
import { useHandleUrl } from 'hooks/useHandleUrl'
import { useGetAllProjectsByUserAdmin } from 'lib/react-query/queriesProject'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import NotProjectsAvailable from './NotProjectsAvailable'

const LIMIT_PAGINATION = 8

const ProyectosList = ({ disabled, sort }) => {
  const { user } = useAuth0()
  const navigate = useNavigate()
  const { changeLocation } = useHandleUrl()
  const [searchParams, setSearchParams] = useSearchParams()

  const page = parseInt(searchParams.get('page')) || 1
  const search = searchParams.get('search')

  const { data, isFetching } = useGetAllProjectsByUserAdmin(user.sub, {
    isUser: true,
    disabled,
    page,
    limit: LIMIT_PAGINATION,
    sort,
    search,
    enabled: true,
  })

  // Calculamos el total de páginas si hay data
  const totalPages = data ? Math.ceil(data.total / LIMIT_PAGINATION) : 0

  // Función para actualizar la página en la URL
  const handlePageProyectos = currentPage => {
    if (currentPage < 1 || currentPage > totalPages) return
    setSearchParams({
      filter: searchParams.get('filter') || 'Todos',
      sort: searchParams.get('sort') || 'createdAt-desc',
      page: currentPage,
      search: search || '',
    })
  }

  const goToViewer = idProject => {
    navigate(changeLocation(`/viewer/${idProject}`))
  }

  if (isFetching) return <ProyectosArraySkeleton length={8} />
  if (!data || data.data.data.length === 0) return <NotProjectsAvailable />

  return (
    <div className="proyectos-container-layout">
      <div className="proyectos-container">
        {data.data.data.map(item => (
          <ProyectoCardItem
            key={item._id}
            item={item}
            handleOnClick={() => goToViewer(item._id)}
          />
        ))}
      </div>

      {/* Paginación actualizada */}
      {Math.ceil(data.total / LIMIT_PAGINATION) !== 1 && (
        <Pagination
          currentPage={page}
          totalPages={Math.ceil(data.total / LIMIT_PAGINATION)}
          handlePage={value => handlePageProyectos(value)}
        />
      )}
    </div>
  )
}

export default ProyectosList
